var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.0007 15H21.2507V25.4167C21.2507 26.1 20.684 26.6667 20.0007 26.6667C19.3173 26.6667 18.7507 26.1 18.7507 25.4167V15H12.0007C6.66732 15 3.33398 18.3333 3.33398 23.6667V27.9833C3.33398 33.3333 6.66732 36.6667 12.0007 36.6667H27.984C33.3173 36.6667 36.6507 33.3333 36.6507 28V23.6667C36.6673 18.3333 33.334 15 28.0007 15Z",
    fill: "#19263F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.2491 7.60039L24.6991 11.0504C24.9491 11.3004 25.2658 11.4171 25.5824 11.4171C25.8991 11.4171 26.2158 11.3004 26.4658 11.0504C26.9491 10.5671 26.9491 9.76706 26.4658 9.28372L20.8824 3.70039C20.3991 3.21706 19.5991 3.21706 19.1158 3.70039L13.5324 9.28372C13.0491 9.76706 13.0491 10.5671 13.5324 11.0504C14.0158 11.5337 14.8158 11.5337 15.2991 11.0504L18.7491 7.60039V15.0004H21.2491V7.60039Z",
    fill: "#19263F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.fc004257da72a6d027efd51728731abe.svg";
export { ForwardRef as ReactComponent };